import React from 'react'
import { connect } from 'react-redux'
import Text from 'antd/es/typography/Text'

const FileGroupYReasoning = ({ drawer }) => {
    return (
        <div>
            <label htmlFor='reasoning'>
                <Text type='secondary'>Group Y reasoning</Text>
            </label>
            <div id='reasoning' dangerouslySetInnerHTML={{ __html: drawer.file.group_y_reason }} />
        </div>
    )
}

const mapState = ({ assignment }) => {
    return {
        drawer: assignment.drawer,
    }
}

export default connect(mapState, null)(FileGroupYReasoning)
